import { Language } from "../../i18n/types";

type FormatCurrencyInput = {
  value: number;
  currency: string;
};

export const formatCurrency = ({ value, currency }: FormatCurrencyInput): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 2
  }).format(value);

/**
 * cdandlp.com language codes:
 * - lng=1: French
 * - lng=2: English
 * - lng=3: Japanese
 * - lng=4: Spanish
 * - no lng param: German (default)
 */
const CDANDLP_LANGUAGE_MAP: Record<Language, string | null> = {
  fr: "1",
  en: "2",
  de: null, // German is cdandlp default, no lng param needed
  pl: "2",  // Polish not supported by cdandlp, fallback to English
};/**
 * Appends the correct lng parameter to cdandlp buy links based on user language.
 */
export const appendCdandlpLanguage = (url: string, language: Language): string => {
  const lngValue = CDANDLP_LANGUAGE_MAP[language];
  if (!lngValue) return url; // German - no lng param needed

  // Check if URL already has query params
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}lng=${lngValue}`;
};
